<div id="loding" [ngClass]="{ 'loding-hide': lodingImage }">
    <img src="assets/img/loding.gif">
</div>

<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-lg-12 headboxes">
                <div class="card p-0">
                    <div class="card-block p-0">
                        <div class="heading-box" style="background-image:none;">
                            <div class="row align-items-center">
                                <div class="col-md-1">
                                    <div class="partner-iocn">
                                        <img *ngIf="atrDetails.full_image" [src]="atrDetails.full_image" style="height: 100px;width: 100px;">
                                        <img *ngIf="!atrDetails.full_image" src="assets/img/default-profile.png" class="img-fluid" alt="">
                                    </div>
                                  </div>
                                  
                                <div class="col-md-4 align-self-center">
                                    <div class="pagename">

                                        <h3 class="card-title mb-1">{{atrDetails.name}}</h3>
                                        <!-- <p>Established on {{atrDetails.announcement_date}}</p> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                <div class="col-lg-12">
                    <div class="card">
                        <div class="card-block partnerview">
                            
                                        <div class="row">
                                            <div class="col-md-12">
                                                <h4>ATR Details</h4>
                                                <hr>
                                            </div>
<!--                                             
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Partner Logo</label>
                                                    <img [src]="atrDetails.full_image" style="height: 100px;width: 100px;">
                                                </div>
                                            </div> -->

                                            <div class="col-md-6  ">
                                                <div class="form-group">
                                                    <label for="">Name of Enterprise</label>
                                                    <p>{{atrDetails.name}}</p>
                                                </div>
                                             </div>

                                            <div class="col-md-6  ">
                                                <div class="form-group">
                                                    <label for="">Description</label>
                                                    <p>{{atrDetails.descriptions}}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-6  ">
                                                <div class="form-group">
                                                    <label for="">Eligibility</label>
                                                    <p>{{atrDetails.eligibility}}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-6  ">
                                                <div class="form-group">
                                                    <label for="">Mode</label>
                                                    <p>{{atrDetails.mode}}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-6  ">
                                                <div class="form-group">
                                                    <label for="">Focus Region</label>
                                                    <p>{{atrDetails.focus_region}}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-6  ">
                                                <div class="form-group">
                                                    <label for="">Focus Region Name</label>
                                                    <p>{{atrDetails.focus_region_name}}</p>
                                                </div>
                                            </div>
                                                                                   
                                            <div class="col-md-12">
                                                <h4>Competetion</h4>
                                                <hr>
                                            </div>
                                            
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Entity</label>
                                                    <p>{{competetion.competition_entity}}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Detail</label>
                                                    <p>{{competetion.competetion_detail}}</p>
                                                </div>
                                            </div>

                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Criteria</label>
                                                    <p>{{competetion.competetion_criteria}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Process</label>
                                                    <p>{{competetion.competition_process}}</p>
                                                </div>
                                            </div>
                                            
                                            <div class="col-md-12">
                                                <h4>Handholding</h4>
                                                <hr>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Sector Name
                                                    </label>
                                                    <p>{{handholding.sector_name
                                                    }}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Stage Of Enterprise Name</label>
                                                    <p>{{handholding.stage_of_enterprise_name}}</p>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Handholding Support Details
                                                    </label>
                                                    <p>{{handholding.handholding_support_details}}
                                                       </p>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Ecosystem Need Name</label>
                                                    <p>{{handholding.ecosystem_need_name}}</p>
                                                </div>
                                            </div>
                                            </div>

                                            <div class="col-md-12">
                                                <h4>Reward</h4>
                                                <hr>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Reward Details
                                                    </label>
                                                    <p>{{reward.reward_details}}</p>
                                                </div>
                                              </div>
                                            </div>

                                            <div class="col-md-12">
                                                <h4>Award Ceremony</h4>
                                                <hr>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <label for="">Award Ceremony Details
                                                    </label>
                                                    <p>{{award_ceremony.award_ceremony_details}}</p>
                                                </div>
                                               </div>
                                            </div>
                                        </div>
                                    </div>

                        <div class="card-block">
                            <div class="partner-action p-3">
                                <form method="post" enctype="multipart/form-data" class="form-horizontal" #f="ngForm">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="atr_remarks">Remarks</label>
                                                <form [formGroup]="remarkForm">
                                                    <textarea class="form-control" name="atr_remarks" id="atr_remarks" formControlName="atr_remarks" rows="3"></textarea>
                                                    <div *ngIf="atr_remark.invalid && (atr_remark.dirty || atr_remark.touched)" class="alert">
                                                        <div *ngIf="atr_remark.errors && atr_remark.errors['required']" class="text-danger">This field is required.</div>
                                                    </div>
                                                  </form>
                                               </div> 
                                            </div>
                                        <div class="col-md-12 align-self-center">
                                            <div class="actiobtn">
                                                <!-- <button type="submit" (click)="rejectStatus(remark_val,'SAVE_AS_DRAFT')" 
                                                class="btn btn-dark mr-2" >Save as Draft</button> -->
                                                <button type="submit" (click)="saveSubmit(remark_val,'APPROVED')" 
                                                class="btn btn-primary mr-2 addbtn" >Approve</button>
                                                <button type="submit" (click)="rejectStatus(remark_val,'REJECTED')" 
                                                class="btn btn-success addbtn mr-2">Reject</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div> 
                    </div>
                </div>
            </div>
        </div>
    </div>